
import { Vue } from "vue-class-component";

export default class Hanging extends Vue {}
